<template>
  <div>
    <div class="more-product-bg">
      <nav-bar class="d-md-block d-none"></nav-bar>
      <div>
        <div v-if="productsArray.length>0">
          <div class="container">
            <div class="row">
              <h1 class="col-auto text-center border-bottom-title mb-6">
                {{pageTitle}}
              </h1>
            </div>
            <div class="row">
              <router-link :to="'productDetail1?ProductID='+item.ProductID"
                           class="col-lg-3 col-md-4 col-sm-6 col-6 px-2" v-for="item in productsArray"
                           :key="item.ProductID">
                <v-card>
                  <div class="text-left" v-if="item.Description !== null">
                    <v-btn
                        icon
                        x-small
                        class="m-2 more-product-info"
                        @click="moreProductsDescription(item.Description)"
                    >
                      <i class="fas fa-info white--text"></i>
                    </v-btn>
                  </div>
                  <div class="text-left" v-else>
                    <v-btn

                        icon
                        x-small
                        class="m-2 more-product-info invisible"
                        @click="moreProductsDescription(item.Description)"
                    >
                      <i class="fas fa-info white--text"></i>
                    </v-btn>
                  </div>
                  <v-img :src="$replaceHttps(item.PictureUrl)" height="175" class="m-2"
                         contain></v-img>
                  <div :class="item.Discount === 0 ? 'visibility-hidden':true">
                    <div class="discount-bg white--text px-3 py-1 mr-3 d-inline-block">
                      <span>%</span> <span>{{ item.Discount }} </span>
<!--                      <span>تخفیف</span>-->
                    </div>
                  </div>
                  <div class="mt-10 text-center font-weight-bold">
                    {{ item.Name }}
                  </div>
                  <div v-if="item.CallForPrice" class="mt-3 text-center">
                    <v-btn color="secondary" elevation="0" to="contactUs"><span class="font-12">برای اطلاع از قیمت <br> تماس بگیرید</span>
                    </v-btn>
                  </div>
                  <div v-else-if="item.Discount === 0" class="mt-3 text-center  add-to-cart">
                    {{ $numberWithCommas(item.Price) }}
                    تومان
                  </div>
                  <div v-else class="mt-3 text-center  add-to-cart">
                    <span class="text-decoration-line-through grey--text font-12">
                      {{$numberWithCommas(item.Price)}}</span>
                    {{ $computingPriceOffer(item.Price, item.Discount) }}
                    تومان
                  </div>
                  <div v-if="item.NotAvailable === true" class="mt-3 text-center add-to-cart">
                    اتمام موجودی
                  </div>

                  <router-link :to="'productDetail1?ProductID='+item.ProductID"
                               class="black--text py-2">
                    <div class="see-product mt-2">
                      <div class="text-center py-3">
                        مشاهده
                        کالا
                      </div>
                    </div>
                  </router-link>
                </v-card>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
    <v-dialog
        v-model="moreProductsDescriptionDialog"
        width="400">
      <div class="white-bg text-right">
        <div class="p-2">{{ moreProductsDescriptionDialogTxt }}</div>
        <div class="text-right p-3">
          <v-btn
              color="gray"
              small
              @click="moreProductsDescriptionOk">
            ok
          </v-btn>
        </div>
      </div>
    </v-dialog>
    <Footer/>
    <navigationDrawer/>

  </div>
</template>

<script>
import navBar from "./navBar";
import navigationDrawer from "./navigationDrawer";
import Footer from "./Footer";

export default {
  name: "moreProducts",
  props: {
    productsArray: Array,
    pageTitle: String
  },
  components: {
    Footer,
    navBar,
    navigationDrawer,
  },
  data: () => ({
    moreProducts: [],
    moreProductsDescriptionDialog: false,
    moreProductsDescriptionDialogTxt: null,

  }),

  created() {
    window.addEventListener('scroll', this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  mounted() {
    setTimeout(() => {
      if (document.documentElement.scrollHeight > this.$getScrollPos())
        window.scrollTo(0, this.$getScrollPos())
    }, 300);

  },
  methods: {
    getImgUrl(pic) {
      return require('../assets/img/' + pic)
    },
    moreProductsDescription(dialogText) {
      this.moreProductsDescriptionDialog = true
      this.moreProductsDescriptionDialogTxt = dialogText
    },
    moreProductsDescriptionOk() {
      this.moreProductsDescriptionDialog = false
    },
    handleScroll() {
      this.$setScrollPos(window.scrollY);
      //window.location.hash = window.scrollY;
      // Any code to be executed when the window is scrolled
    }
  },

}
</script>

<style scoped>

</style>
